import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import SampleCategoriesSection from "./sample-categories-section";

export default function SampleCategoriesPage() {
  return (
    <>
      <Header />
      <SampleCategoriesSection />
    </>
  );
}
